import { render, staticRenderFns } from "./FormAlerts.vue?vue&type=template&id=f7404aa4"
import script from "./FormAlerts.vue?vue&type=script&lang=ts"
export * from "./FormAlerts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports